import { render } from "./NotificationsContainer.vue?vue&type=template&id=795b95e7&ts=true"
import script from "./NotificationsContainer.vue?vue&type=script&lang=ts"
export * from "./NotificationsContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__